export default __webpack_public_path__ + "static/media/Frame 607.2380e51d.png";